import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import Select from '@/components/ui/Select/Select';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const ORIGINAL_PARTS_USED_FOR_REPAIR = {
  YES: 'yes',
  NO: 'no',
  IDK: 'does_not_know',
} as const;

export const ORIGINAL_PARTS_USED_FOR_REPAIR_NAME =
  'original_parts_used_for_repair_detailed';

export const ORIGINAL_PARTS_USED_FOR_REPAIR_NAME_COMPLEMENTARY =
  'original_parts_used_for_repair_detailed_complementary';
interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const SelectOriginalPartsUsedForRepair: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary
      ? ORIGINAL_PARTS_USED_FOR_REPAIR_NAME_COMPLEMENTARY
      : ORIGINAL_PARTS_USED_FOR_REPAIR_NAME);

  const data = [
    { value: 'new_original_parts', label: i18n.t('Nowe oryginalne części') },
    {
      value: 'used_original_parts',
      label: i18n.t('Używane oryginalne części'),
    },
    { value: 'new_replacement_parts', label: i18n.t('Nowe zamienniki') },
    {
      value: 'used_replacement_parts',
      label: i18n.t('Używane zamienniki'),
    },
    { value: 'no_need_to_replace', label: i18n.t('Bez konieczności wymiany') },
  ];

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel>{i18n.t('Jakich części użyto do naprawy?')}</FormLabel>
          <FormControl>
            <Select
              placeholder={i18n.t('Wybierz')}
              success={!fieldState.error && field.value}
              options={data}
              {...field}
              data-testid="select-original-parts-used-for-repair"
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};
